import { render, staticRenderFns } from "./gymBsquat.vue?vue&type=template&id=760090f6&"
import script from "./gymBsquat.js?vue&type=script&lang=js&"
export * from "./gymBsquat.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports